import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { mockTeamMembers } from '../data/mockData';
export function TeamWorkload() {
  // Sort team members by active tickets for the chart
  const chartData = [...mockTeamMembers].filter(tm => tm.name !== 'Unassigned').sort((a, b) => b.activeTickets - a.activeTickets);
  return <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 h-full flex flex-col" data-id="element-86">
      <h2 className="text-lg font-bold text-gray-900 mb-6" data-id="element-87">Team Operations</h2>

      <div className="flex-1 space-y-8" data-id="element-88">
        <div data-id="element-89">
          <h3 className="text-sm font-semibold text-gray-700 mb-4" data-id="element-90">
            Workload Distribution
          </h3>
          <div className="h-48 w-full" data-id="element-91">
            <ResponsiveContainer width="100%" height="100%" data-id="element-92">
              <BarChart data={chartData} layout="vertical" margin={{
              top: 0,
              right: 20,
              left: 0,
              bottom: 0
            }} data-id="element-93">
                <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#f3f4f6" data-id="element-94" />
                <XAxis type="number" hide data-id="element-95" />
                <YAxis dataKey="name" type="category" axisLine={false} tickLine={false} tick={{
                fontSize: 12,
                fill: '#6b7280'
              }} width={80} data-id="element-96" />
                <Tooltip cursor={{
                fill: '#f9fafb'
              }} contentStyle={{
                borderRadius: '8px',
                border: '1px solid #e5e7eb',
                boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
              }} data-id="element-97" />
                <Bar dataKey="activeTickets" radius={[0, 4, 4, 0]} barSize={20} data-id="element-98">
                  {chartData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.activeTickets > 10 ? '#ef4444' : entry.activeTickets > 5 ? '#3b82f6' : '#10b981'} data-id="element-99" />)}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div data-id="element-100">
          <h3 className="text-sm font-semibold text-gray-700 mb-4" data-id="element-101">
            Team Performance
          </h3>
          <div className="overflow-x-auto" data-id="element-102">
            <table className="w-full text-left text-sm" data-id="element-103">
              <thead data-id="element-104">
                <tr className="text-gray-500 border-b border-gray-100" data-id="element-105">
                  <th className="pb-2 font-medium" data-id="element-106">Admin</th>
                  <th className="pb-2 font-medium text-center" data-id="element-107">Active</th>
                  <th className="pb-2 font-medium text-center" data-id="element-108">Avg Resp</th>
                  <th className="pb-2 font-medium text-center" data-id="element-109">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50" data-id="element-110">
                {mockTeamMembers.filter(tm => tm.name !== 'Unassigned').map(member => <tr key={member.id} data-id="element-111">
                      <td className="py-2 font-medium text-gray-800" data-id="element-112">
                        {member.name}
                      </td>
                      <td className="py-2 text-center text-gray-600" data-id="element-113">
                        {member.activeTickets}
                      </td>
                      <td className="py-2 text-center text-gray-600" data-id="element-114">
                        {member.avgResponseTime}m
                      </td>
                      <td className="py-2 text-center" data-id="element-115">
                        <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${member.status === 'Available' ? 'bg-green-100 text-green-700' : member.status === 'Busy' ? 'bg-amber-100 text-amber-700' : 'bg-gray-100 text-gray-700'}`} data-id="element-116">
                          {member.status}
                        </span>
                      </td>
                    </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>;
}